import { render, staticRenderFns } from "./setNav.vue?vue&type=template&id=09f1a358&scoped=true&"
import script from "./setNav.vue?vue&type=script&lang=js&"
export * from "./setNav.vue?vue&type=script&lang=js&"
import style0 from "./setNav.vue?vue&type=style&index=0&id=09f1a358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f1a358",
  null
  
)

export default component.exports